module.exports = __webpack_public_path__ + "assets/de259a64e03345fc6f862204007b706c.mp4";